import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { Company } from '../types/company';

export function useCompany(id: string) {
  const [company, setCompany] = useState<Company | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchCompany() {
      // Skip fetch if no id is provided
      if (!id) {
        setCompany(null);
        setLoading(false);
        return;
      }

      try {
        const { data, error: fetchError } = await supabase
          .from('nrm_companies')
          .select('*')
          .eq('id', id)
          .single();

        if (fetchError) throw fetchError;
        setCompany(data);
      } catch (err) {
        setError('Failed to load company details');
        console.error('Fetch error:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchCompany();
  }, [id]);

  return { company, loading, error };
}